import React from "react";
import ProjectCard from "../projects/ProjectCard";
import "../projects/ProjectList.css";
import querio from "../assets/querio.jpg";
import mids from "../assets/mids.jpg";
import first from "../assets/first-principles.png";
import ijmuiden from "../assets/ijmuiden.jpg";
import hourglass from "../assets/hourglass.jpg";
import euler from "../assets/euler_portrait.png";
import { Helmet } from "react-helmet";

function ProjectList() {
  const projects = [
    {
      title: "Ijmuiden cross-current estimation using machine learning",
      description:
        "A modeling project around cross-current estimation for Ijmuiden, combining neural networks with physical water-system context.",
      imageUrl: ijmuiden,
      tags: ["Machine learning", "ADCP", "Delft3D"],
      status: "Research engineering",
      link: "https://yazanmashal03.github.io/ijmuiden_cross-current/",
    },
    {
      title: "Machine learning from first principles",
      description:
        "A from-scratch implementation project inspired by core learning algorithms, rebuilt to understand the mechanics rather than only the interface.",
      imageUrl: first,
      tags: ["Machine learning", "TensorFlow", "NumPy", "Pandas"],
      status: "Learning systems",
      link: "https://github.com/yazanmashal03/ml-from-first",
    },
    {
      title: "Querio",
      description:
        "Built features for an operational platform used inside imec, focused on streamlining day-to-day workflows for a high-tech environment.",
      imageUrl: querio,
      tags: ["PHP", "MySQL", "CSS", "Docker", "HTML"],
      status: "Industry collaboration",
      link: "https://querio.imec.be/",
    },
    {
      title: "MIDS",
      description:
        "A stock and process management system developed with NextSelect for MASER, designed around practical internal use.",
      imageUrl: mids,
      tags: ["PHP", "MySQL", "CSS", "Docker", "HTML"],
      status: "Operations software",
      link: "https://mids.maser.nl/",
    },
    {
      title: "Project Euler",
      description: "A personal repository for solving Project Euler problems as a way to keep mathematical programming sharp.",
      imageUrl: euler,
      tags: ["Python", "Mathematical programming"],
      status: "Ongoing practice",
      link: "https://github.com/yazanmashal03/project-euler",
    },
    // {
    //   title: "Drainer",
    //   description:
    //     "A minimal reminder of how much of the year has passed and how much remains, built as a small reflective experiment.",
    //   imageUrl: hourglass,
    //   tags: ["JavaScript", "Interactive"],
    //   status: "Personal tool",
    //   link: "https://yazanmashal.com/drainer",
    // },
  ];

  return (
    <div className="project-list page-shell">
      <Helmet>
        <title>Projects | Yazan Mash'Al</title>
      </Helmet>

      <section className="projects-hero section-panel">
        <span className="eyebrow">Projects</span>
        <h1 className="page-title">Things I have built, tested, or explored.</h1>
        <p className="page-intro">
          This work ranges from research-adjacent engineering to small personal experiments. The common
          thread is that I prefer systems that reveal how they work.
        </p>
      </section>

      <section className="project-items-container">
        {projects.map((project) => (
          <ProjectCard
            key={project.title}
            title={project.title}
            description={project.description}
            imageUrl={project.imageUrl}
            tags={project.tags}
            status={project.status}
            link={project.link}
          />
        ))}
      </section>
    </div>
  );
}

export default ProjectList;
